export default __webpack_public_path__ + "static/B202-09ac0bf31fe8967495d54cc58ec49b61.jpg";